import { Directive, HostListener, ElementRef, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[textTrim]'
})
export class TrimSpecialCharactersDirective {
  constructor(
    private el: ElementRef,
    @Optional() private ngControl: NgControl
  ) {}

  @HostListener('blur') onBlur(): void {
    const trimmedValue = this.el.nativeElement.value.replace(/[^a-zA-Z0-9_]/g, '');
    this.ngControl.control.setValue(trimmedValue);
  }
}
